import * as React from "react";
import classNames from "classnames";

export const CharCount: React.FC<{
  text: string;
  maxLength: number;
}> = ({ text, maxLength }) => {
  return (
    <>
      <p
        className={classNames("has-text-right", {
          "has-text-danger": text.length > maxLength,
        })}
      >
        {text.length}/{maxLength}
      </p>
    </>
  );
};
